import React from 'react';

import Dossier from '../../../../components/Molecules/Dossier';
import { TAXONOMY_STAGEOFLIFE, TAXONOMY_LOCATION, TAXONOMY_SUBJECT, TAXONOMY_DOSSIER, TAXONOMY_WORKFIELD } from '../../../../config/constants';

const DossierTeaser = ({ entity }) => {
  const typeMapper = {
    [TAXONOMY_STAGEOFLIFE]: 'Levensfase',
    [TAXONOMY_WORKFIELD]: 'Werkveld',
    [TAXONOMY_SUBJECT]: 'Onderwerp',
    [TAXONOMY_LOCATION]: 'Locatie',
    [TAXONOMY_DOSSIER]: 'Dossier',
  };

  return (
    <Dossier
      name={entity.getIn(['name', 0, 'value'], '')}
      type={typeMapper[entity.getIn(['vid', 0, 'target_id']) || null]}
      image={entity.getIn(['field_media_image', 0, 'styles', 'paragraph_image'])}
      link={entity.getIn(['paths', 'nl'])}
    />
  );
};

export default DossierTeaser;
